import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

import { IOrganization} from 'shared/types/organization';

const { persistAtom } = recoilPersist();

export const organizationList = atom<IOrganization[]>({
  key: 'organizations',
  default: [],
  effects_UNSTABLE: [persistAtom],
});

export const selectedOrganization = atom<IOrganization | null>({
  key: 'selectedOrganization',
  default: null,
  effects_UNSTABLE: [persistAtom],
});
